import React, { ReactNode, useContext } from 'react';

import BuildingSummaryContext from '@totem/components/portfolio/buildings/list/buildingSummary/buildingSummaryContext';
import { BuildingSummaryFilters } from '@totem/components/portfolio/buildings/list/buildingSummary/types';
import SquareFootageContainer from '@totem/components/portfolio/buildings/list/squareFootage/SquareFootageContainer';

type Props = {
  staticFilters?: BuildingSummaryFilters;
  children?: ReactNode;
};

const SquareFootageWrapper = ({ staticFilters, children }: Props) => {
  const { input } = useContext(BuildingSummaryContext);
  return (
    <SquareFootageContainer staticFilters={staticFilters} input={input}>
      {children}
    </SquareFootageContainer>
  );
};

export default SquareFootageWrapper;
